(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-home-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-vv-banner-slider]').forEach(function (slider) {
      const slides = Array.from(slider.querySelectorAll('[data-vv-banner-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-vv-banner-dot]'));
      const prev = slider.querySelector('[data-vv-banner-prev]');
      const next = slider.querySelector('[data-vv-banner-next]');
      if (slides.length < 2) return;

      let index = 0;
      let startX = null;
      let timer = null;
      let inView = true;
      let pointerInside = false;
      let focusInside = false;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(nextIndex) {
        if (window.matchMedia('(max-width: 749px)').matches) nextIndex = 0;
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach(function (dot, dotIndex) {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function stopTimer() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function startTimer() {
        stopTimer();
        if (reduceMotion || !inView || document.hidden || pointerInside || focusInside) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, 6500);
      }

      prev.addEventListener('click', function () {
        show(index - 1);
        startTimer();
      });

      next.addEventListener('click', function () {
        show(index + 1);
        startTimer();
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-vv-banner-dot')));
          startTimer();
        });
      });

      slider.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
      });

      slider.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        const distance = event.clientX - startX;
        startX = null;
        if (Math.abs(distance) < 45) return;
        show(distance < 0 ? index + 1 : index - 1);
        startTimer();
      });

      slider.addEventListener('mouseenter', function () { pointerInside = true; stopTimer(); });
      slider.addEventListener('mouseleave', function () { pointerInside = false; startTimer(); });
      slider.addEventListener('focusin', function () { focusInside = true; stopTimer(); });
      slider.addEventListener('focusout', function (event) { focusInside = slider.contains(event.relatedTarget); startTimer(); });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries) {
          inView = entries[0]?.isIntersecting ?? true;
          if (inView) startTimer();
          else stopTimer();
        }, { threshold: 0.15 });
        observer.observe(slider);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopTimer();
        else startTimer();
      });

      show(0);
      startTimer();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
